__turbopack_context__.v({
  "card": "GameGenres-module__TbyRKW__card",
  "eyebrow": "GameGenres-module__TbyRKW__eyebrow",
  "grid": "GameGenres-module__TbyRKW__grid",
  "image": "GameGenres-module__TbyRKW__image",
  "imageWrap": "GameGenres-module__TbyRKW__imageWrap",
  "label": "GameGenres-module__TbyRKW__label",
  "section": "GameGenres-module__TbyRKW__section",
  "subtitle": "GameGenres-module__TbyRKW__subtitle",
  "title": "GameGenres-module__TbyRKW__title",
});
